


























import Vue from 'vue'
import Component from 'vue-class-component'
import {
  validateEmail,
  validatePhone,
  validateWebsite,
  validateEIN,
  validateSSN,
  validateZip,
  validateDate
} from '@/utils/helpers'

@Component({
  // inheritAttrs: true,
  props: {
    validation: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
      default: ''
    },
    precision: {
      type: Number,
      default: 2
    },
    subType: {
      type: String
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    validateIfInputted: {
      type: Boolean,
      default: false
    }
  }
})
export default class Input extends Vue {
  isError: boolean = false;
  isDirty: boolean = false;
  fakeId: number = 0;

  emitInput (e: any) {
    let value = e.target.value
    this.isDirty = true
    
    if (this.$props.type === 'number' && this.$props.subType !== 'amount') {
      if (Number.isNaN(+value)) {
        value = parseFloat(value).toFixed(this.$props.precision)
      }
      if (this.$props.subType === 'positive' && parseFloat(value) < 0) {
        value = Math.abs(value).toFixed(this.$props.precision)
      }
      (this.$refs.inputRef as any).value = value
    }
    
    this.$emit('input', value)
    if (this.$props.validation) {
      this.validate(e.target.value)
    }
  }

  validate (value: string) {
    if (this.$props.validateIfInputted && (value === '' || !value)) {
      this.isError = false
      return
    }
    value = value || (this.$refs.inputRef as any).value
    switch (this.$props.validation) {
      case 'text':
        this.validateTextField(value)
        break
      case 'email':
        this.validateEmailField(value)
        break
      case 'phone':
        this.validatePhoneField(value)
        break
      case 'ein':
        this.validateEINField(value)
        break
      case 'ssn':
        this.validateSSNField(value)
        break
      case 'website':
        this.validateWebsiteField(value)
        break
      case 'zip':
        this.validateZipField(value)
        break
      case 'routing':
        this.validateRoutingField(value)
        break
      case 'routingNotRequired':
        this.validateRoutingFieldNotRequired(value)
        break
      case 'date':
        this.validateDateField(value)
        break
      case 'number':
        this.validateNumberField(value)
        break
      default:
        break
    }
    this.$forceUpdate()
  }

  validateRoutingField (value: string) {
    this.isError = !/^\d{9}$/.test(value)
  }

  validateRoutingFieldNotRequired (value: string) {
    this.isError = value.length > 0 ? !/^\d{9}$/.test(value) : false
  }

  validateZipField (value: string) {
    this.isError = !validateZip(value)
  }

  validateEINField (value: string) {
    this.isError = !validateEIN(value)
  }

  validateSSNField (value: string) {
    this.isError = !validateSSN(value)
  }

  validateWebsiteField (value: string) {
    this.isError = !validateWebsite(value)
  }

  validatePhoneField (value: string) {
    this.isError = !validatePhone(value)
  }

  validateEmailField (value: string) {
    this.isError = !validateEmail(value)
  }

  validateTextField (value: string) {
    this.isError = !value
  }

  validateDateField (value: string) {
    this.isError = !validateDate(value)
  }

  validateNumberField (value: string) {
    this.isError = !value || isNaN(Number(value))
  }

  emit (eventName: string, e: any) {
    this.$emit(eventName, e)
    this.emitInput(e)
  }

  randomValue () {
    return Math.random() * 100000000
  }

  resetValidation () {
    this.isError = false
  }

  mounted () {
    this.validate = this.validate.bind(this)
    this.resetValidation = this.resetValidation.bind(this)
    this.$eventBus.$on('Input:validate:reset', this.resetValidation)
    this.$eventBus.$on('Input:validate', this.validate)
    if (!this.$props.id) {
      this.fakeId = this.randomValue()
    }
  }

  beforeDestroy () {
    this.$eventBus.$off('Input:validate:reset', this.resetValidation)
    this.$eventBus.$off('Input:validate', this.validate)
  }
}
